import type { ReactNode } from "react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./card";

/**
 * A titled card of a page. The section is named by its heading (`id` is the id of the `h2`), so a screen reader lists it as a region.
 * `actions` sit to the right of the title and wrap under it on a narrow screen.
 */
export function Panel({
  id,
  title,
  description,
  actions,
  children,
  className,
  testId,
}: Readonly<{
  id: string;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  /** A fixed test hook (never customer text). */
  testId?: string;
}>) {
  return (
    <section aria-labelledby={id} data-testid={testId}>
      <Card className={className}>
        <CardHeader>
          <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
            <CardTitle id={id}>{title}</CardTitle>
            {actions}
          </div>
          {description === undefined ? null : <CardDescription>{description}</CardDescription>}
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </section>
  );
}
